import { useEffect } from "react";
import { useRecoilValue, useRecoilState } from "recoil";
import { reportsState } from "../atoms/atoms";

import { currentAccountState } from "../../../components";
import { currencyFormatter } from "../../../utils/helpers";
import { parseISO, format } from "date-fns";
import { Buffer } from "buffer";
import { formatToTimeZone } from "date-fns-timezone";

import Loading from "../../../components/loading/loading";
import { moneyFormat } from "../../../utils/moneyFormat";
import { createReportExcelFile } from "../excel/excel";
import ExportToExcel from "../exportExcel";
import pdf from "../../../assets/pdf.svg";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
//require("dotenv").config();

export default function Statement() {
  const { getCurrentAccount } = useRecoilValue(currentAccountState);
  const [state, setState] = useRecoilState(reportsState);

  useEffect(() => {
    setState((old) => ({
      ...old,
      isLoading: true,
    }));
    console.log("log url env","us-central1-prod-prepaidplus");

    const apiKey = getCurrentAccount().api_key;
    const encodedString = Buffer.from(apiKey).toString("base64");
    // const encodedString = getCurrentAccount().buffer;

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Basic ${encodedString}`);
    myHeaders.append("Content-Type", "application/json");

    const reportStartDate = state.startDate.startOf("day").toDate();
    const reportEndDate = state.endDate.endOf("day").toDate();

    var raw = {
      reportStartDate: format(reportStartDate, "yyyy-MM-dd"),
      reportEndDate: format(reportEndDate, "yyyy-MM-dd"),
    };

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(raw),
    };
    const baseUrl = "us-central1-prod-prepaidplus";

    console.log("requestOptions", requestOptions);
    console.log(
      "log url",
      `https://${baseUrl}.cloudfunctions.net/apikey-selfServiceFinancials`
    );

    fetch(
      `https://${baseUrl}.cloudfunctions.net/apikey-selfServiceFinancials`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("data", data);

        setState((old) => ({
          ...old,
          isLoading: false,
          statement: data,
        }));
      })
      .catch((error) => console.log("error", error));
  }, [state.startDate, state.endDate]);

  const transactionsSheet = async (
    transactions,
    workbook,
    logo,
    reportStartDate,
    reportEndDate,
    merchantName
  ) => {
    let startDate = format(reportStartDate.toDate(), "yyyy-MM-dd");
    let endDate = format(reportEndDate.toDate(), "yyyy-MM-dd");

    let worksheet = workbook.addWorksheet("Statement", {
      properties: {
        showGridLines: false,
      },
      pageSetup: {
        paperSize: 9,
        fitToPage: true,
        orientation: "portrait",
      },
      views: [
        {
          state: "frozen",
          xSplit: 9,
          activeCell: "G1",
          showGridLines: false,
        },
      ],
    });

    worksheet.mergeCells("A1", "D2");
    worksheet.addImage(logo, {
      tl: {
        col: 0.25,
        row: 0.25,
      },
      ext: {
        width: 150,
        height: 32,
      },
    });

    worksheet.mergeCells("A3", "D3");

    worksheet.mergeCells("A4", "B4");
    worksheet.getCell("A4").value = {
      richText: [
        {
          font: {
            size: 12,
            color: {
              argb: "FF000000",
            },
            name: "Calibri",
            family: 4,
            scheme: "minor",
          },
          text: "For ",
        },
        {
          font: {
            size: 12,
            color: {
              argb: "FF000000",
            },
            bold: true,
            name: "Calibri",
            family: 4,
            scheme: "minor",
          },
          text: `${merchantName}`,
        },
      ],
    };

    worksheet.mergeCells("A5", "D5");

    worksheet.mergeCells("A6", "B6");
    worksheet.getCell("A6").value = `Statement For Period`;
    worksheet.getRow(6).font = {
      name: "Calibri",
      family: 4,
      size: 16,
      bold: true,
    };

    worksheet.mergeCells("A7", "D7");

    worksheet.mergeCells("A8", "B8");
    worksheet.getCell("A8").value = {
      richText: [
        {
          font: {
            size: 12,
            color: {
              argb: "FF000000",
            },
            name: "Calibri",
            family: 4,
            scheme: "minor",
          },
          text: "Date From ",
        },
        {
          font: {
            size: 12,
            color: {
              argb: "FF000000",
            },
            bold: true,
            name: "Calibri",
            family: 4,
            scheme: "minor",
          },
          text: `${startDate}`,
        },
        {
          font: {
            size: 12,
            color: {
              argb: "FF000000",
            },
            name: "Calibri",
            family: 4,
            scheme: "minor",
          },
          text: " to ",
        },
        {
          font: {
            size: 12,
            color: {
              argb: "FF000000",
            },
            bold: true,
            name: "Calibri",
            family: 4,
            scheme: "minor",
          },
          text: `${endDate}`,
        },
      ],
    };

    worksheet.mergeCells("A9", "D9");

    // adjust pageSetup settings afterwards
    worksheet.pageSetup.margins = {
      left: 0.7,
      right: 0.7,
      top: 0.75,
      bottom: 0.75,
      header: 0.3,
      footer: 0.3,
    };

    let headers = worksheet.getRow(10);
    headers.height = 25;
    headers.values = ["Date Time", "Description", "Amount", "Balance"];
    headers.alignment = {
      vertical: "middle",
      horizontal: "left",
    };

    headers.eachCell((cell) => {
      cell.font = {
        name: "Calibri",
        family: 4,
        size: 10,
        color: {
          argb: "FF000000",
        },
        bold: true,
      };
      cell.border = {
        bottom: {
          style: "medium",
        },
      };
    });
    worksheet.columns = [
      {
        key: "dateTime",
        width: 20,
      },
      {
        key: "description",
        width: 24,
      },
      {
        key: "amount",
        width: 18,
      },
      {
        key: "balance",
        width: 24,
      },
    ];

    worksheet.getColumn(2).numFmt = "0000";
    worksheet.getColumn(7).numFmt = "0.00";

    ["A10", "B10", "C10", "D10"].map((key) => {
      worksheet.getCell(key).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: "FFEEEEEE",
        },
      };
    });

    worksheet.addRow([
      format(state.startDate.toDate(), "yyyy-MM-dd HH:mm:ss"),
      "Balance brought forward",
      "",
      currencyFormatter(state.statement.startingBalance),
    ]);

    worksheet.getCell("B11").font = { bold: true };
    worksheet.getCell("D11").font = { bold: true };

    state.statement.selfServiceList.map((transaction, index) =>
      worksheet
        .addRow({
          dateTime: format(
            parseISO(transaction.transactionDateTime),
            "yyyy-MM-dd HH:mm:ss"
          ),
          description: transaction.description,
          amount: +currencyFormatter(transaction.transactionAmount),
          balance: "",
        })
        .commit()
    );

    // worksheet.getColumn(3).numFmt = "#,##0";

    let column3 = worksheet.getColumn(3);
    column3.alignment = {
      vertical: "middle",
      horizontal: "right",
    };
    column3.numFmt = "#,##0.00;[Red]-#,##0.00";
    column3.width = 15;

    let column4 = worksheet.getColumn(4);
    column4.alignment = {
      vertical: "middle",
      horizontal: "right",
    };
    column4.numFmt = "#,##0.00;[Red]-#,##0.00";
    column4.width = 15;

    if (state.statement.totalsByProvider.length > 0) {
      worksheet.addRow([]);
      let totalsByProviderHeaderRow = worksheet.addRow([]);
      let totalsByProviderCurrentRow = totalsByProviderHeaderRow._number;
      worksheet.mergeCells(
        totalsByProviderCurrentRow,
        1,
        totalsByProviderCurrentRow,
        4
      );
      let totalsByProviderHeaderCell = worksheet.getCell(
        "A" + totalsByProviderCurrentRow
      );
      totalsByProviderHeaderCell.value = "Other Channels Sales";
      totalsByProviderHeaderCell.font = {
        bold: true,
      };

      state.statement.totalsByProvider.map((item, index) => {
        let totalsRow = worksheet.addRow([]);
        let currentRow = totalsRow._number;
        worksheet.mergeCells(currentRow, 1, currentRow, 2);
        let totalsCell = worksheet.getCell("A" + currentRow);
        totalsCell.value = `${item.saleType} - ${item.provider}`;
        let totalsAmountCell = worksheet.getCell("C" + currentRow);
        totalsAmountCell.value = +currencyFormatter(item.transactionAmount);
      });

      let totalsHeaderRow = worksheet.addRow([]);
      let currentRow = totalsHeaderRow._number;
      worksheet.mergeCells(currentRow, 1, currentRow, 2);
      let totalsHeaderCell = worksheet.getCell("A" + currentRow);
      totalsHeaderCell.value = "Total Sales";
      totalsHeaderCell.font = {
        bold: true,
      };
      let totalsAmountCell = worksheet.getCell("C" + currentRow);
      totalsAmountCell.value = currencyFormatter(state.statement.salesTotal);

      worksheet.addRow([]);
    }

    if (state.statement.commissionList.length > 0) {
      let commissionListHeaderRow = worksheet.addRow([]);
      let commissionListCurrentRow = commissionListHeaderRow._number;
      worksheet.mergeCells(
        commissionListCurrentRow,
        1,
        commissionListCurrentRow,
        4
      );
      let commissionListHeaderCell = worksheet.getCell(
        "A" + commissionListCurrentRow
      );
      commissionListHeaderCell.value = "Other Channels Commission";
      commissionListHeaderCell.font = {
        bold: true,
      };

      state.statement.totalsByProvider.map((item, index) => {
        let totalsRow = worksheet.addRow([]);
        let currentRow = totalsRow._number;
        worksheet.mergeCells(currentRow, 1, currentRow, 2);
        let totalsCell = worksheet.getCell("A" + currentRow);
        totalsCell.value = `${item.saleType} - ${item.provider}`;
        let totalsAmountCell = worksheet.getCell("C" + currentRow);
        totalsAmountCell.value = +currencyFormatter(item.transactionAmount);
      });

      let totalsHeaderRow = worksheet.addRow([]);
      let currentRow = totalsHeaderRow._number;
      worksheet.mergeCells(currentRow, 1, currentRow, 2);
      let totalsHeaderCell = worksheet.getCell("A" + currentRow);
      totalsHeaderCell.value = "Total Commission";
      totalsHeaderCell.font = {
        bold: true,
      };
      let totalsAmountCell = worksheet.getCell("C" + currentRow);
      totalsAmountCell.value = currencyFormatter(
        state.statement.creditedCommissionListTotal
      );

      worksheet.addRow([]);
    }

    const footerRow = worksheet.addRow([
      format(state.endDate.toDate(), "yyyy-MM-dd HH:mm:ss"),
      "Balance carried forward",
      "",
      currencyFormatter(+state.statement.closingBalance),
    ]);
    footerRow.height = 25;
    footerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: "FFEEEEEE",
        },
      };
    });

    footerRow.getCell(2).font = { bold: true };
    footerRow.getCell(4).font = { bold: true };
  };

  const print = () => {
    const doc = new jsPDF();

    var imgData =
      "data:image/png;base64,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";
    console.log(imgData);
    doc.setFontSize(40);

    doc.addImage(imgData, "PNG", 14, 20, 38.25, 5.4);

    doc.setFontSize(22);
    doc.text(`Merchant Statement`, 56, 25.5);
    doc.setTextColor(100);

    doc.setFontSize(12);
    doc.text(`Merchant - ${getCurrentAccount().merchantName}`, 14, 44);
    doc.setTextColor(100);

    autoTable(doc, {
      theme: "plain",
      headStyles: { fontSize: 10, fontStyle: "bold" },
      bodyStyles: { fontSize: 10, fontStyle: "normal" },
      styles: { cellPadding: 0.5 },
      startY: 48,
      head: [["Start Date", "End Date", "", ""]],
      body: [
        [
          `${format(state.startDate.toDate(), "yyyy-MM-dd")}`,
          `${format(state.endDate.toDate(), "yyyy-MM-dd")}`,
          "",
          "",
        ],
      ],
    });

    autoTable(doc, { html: "#statement-table", startY: 66 });

    doc.save(
      `Statement ${format(state.startDate.toDate(), "yyyyMMdd")}-${format(
        state.endDate.toDate(),
        "yyyyMMdd"
      )}.pdf`
    );
  };

  const exportToExcel = async () => {
    // openModal("SpinnerModal");

    // console.log("clicked on exportToExcel", itemisedPurchasesList);

    await createReportExcelFile(
      "Statement Report",
      state.statement,
      transactionsSheet,
      getCurrentAccount().merchantName,
      state.startDate,
      state.endDate
    );
  };

  return (
    <>
      {state.statement && (
        <div className="w-full lg:max-w-7xl py-4 bg-white overflow-hidden shadow rounded-sm">
          <div className="px-6 pb-6">
            <div className="shadow sm:hidden">
              {/* <ul className="mt-2 divide-y divide-gray-200 overflow-hidden shadow sm:hidden">
            {purchaseOrders.map((transaction) => (
              <li key={transaction.id}>
                <a
                  href={transaction.id}
                  className="block px-4 py-4 bg-white hover:bg-gray-50"
                >
                  <span className="flex items-center space-x-4">
                    <span className="flex-1 flex space-x-2 truncate">
                      <span className="flex flex-col text-gray-500 text-sm truncate">
                        <span className="truncate">{transaction.id}</span>
                        <span>
                          <span className="text-gray-900 font-medium">
                            {currencyFormatter(transaction.amount)}
                          </span>
                        </span>
                        <div>{transaction.date}</div>
                      </span>
                    </span>
                    <ChevronRightIcon
                      className="flex-shrink-0 h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </span>
                </a>
              </li>
            ))}
          </ul>

          <nav
            className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200"
            aria-label="Pagination"
          >
            <div className="flex-1 flex justify-between">
              <a
                href="/"
                className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500"
              >
                Previous
              </a>
              <a
                href="/"
                className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500"
              >
                Next
              </a>
            </div>
          </nav> */}
            </div>

            {/* Activity table (small breakpoint and up) */}
            <div className="hidden  sm:block">
              <div className="px-6 py-4">
                <div className="mb-0">
                  <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12">
                    <div className="sm:col-span-1 my-auto align-middle">
                      <h2 className="mx-auto text-lg leading-6 font-medium text-gray-900">
                        Download:
                      </h2>
                    </div>

                    <div className="lg:col-span-6 flex justify-end">
                      <button
                        onClick={() => exportToExcel()}
                        type="button"
                        className="pr-3 bg-white"
                      >
                        <ExportToExcel />
                      </button>

                      <div className="block cursor-pointer w-auto mr-0">
                        <img
                          className="text-gray-400 h-8 w-8 group-hover:text-gray-900"
                          aria-hidden="true"
                          onClick={() => print()}
                          src={pdf}
                          alt="Download"
                        />
                      </div>
                      {/* <ItemisedAmountTotal transactions={itemisedPurchasesList} /> */}
                    </div>
                  </div>
                </div>
              </div>

              <div className="max-w-7xl mx-auto">
                <div className="flex flex-col mt-2">
                  <div className="align-middle min-w-full flex-grow overflow-x-auto overflow-hidden ">
                    {state.statement !== null ? (
                      <table
                        style={{
                          borderCollapse: "collapse",
                          border: "1px solid #e8e8e8",
                          background: "#f8f8f8",
                        }}
                        id="statement-table"
                      >
                        <thead>
                          <tr style={{ backgroundColor: "#eee" }}>
                            <th
                              className="px-6 py-2 text-left font-medium"
                              scope="col"
                            >
                              Date
                            </th>
                            <th
                              className="px-6 py-2 text-left font-medium"
                              scope="col"
                            >
                              Description
                            </th>
                            <th
                              className="px-6 py-2 text-right font-medium"
                              scope="col"
                            >
                              Amount
                            </th>
                            <th
                              className="px-6 py-2 text-right font-medium"
                              scope="col"
                            >
                              Balance
                            </th>
                            {/* <th scope="col">Sales Value2</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan={4}> </td>
                          </tr>
                          <tr>
                            <td className="px-6 py-1">
                              {format(
                                state.startDate.toDate(),
                                "yyyy-MM-dd HH:mm:ss"
                              )}
                            </td>
                            <td className="px-6 py-1 font-medium">
                              {"Balance brought forward"}
                            </td>
                            <td className="px-6 py-1">{""}</td>
                            <td className="px-6 py-1 font-medium text-right">
                              {currencyFormatter(
                                state.statement.startingBalance
                              )}
                            </td>
                          </tr>
                          {state.statement.selfServiceList.map(
                            (transaction) => (
                              <tr
                                key={transaction.id}
                                className="hover:text-white hover:bg-indigo-700 "
                              >
                                <td className="px-6 py-1">
                                  {format(
                                    new Date(transaction.transactionDateTime),
                                    "yyyy-MM-dd HH:mm:ss"
                                  )}
                                </td>
                                <td className="px-6 py-1">
                                  {transaction.description}
                                </td>
                                <td className="px-6 py-1 text-right">
                                  {currencyFormatter(
                                    transaction.transactionAmount
                                  )}
                                </td>
                                <td className="px-6 py-1 font-medium text-right">
                                  {/* {currencyFormatter(transaction.balance)} */}
                                </td>
                              </tr>
                            )
                          )}

                          <tr>
                            <td className="px-6 py-1 font-medium" colSpan={4}>
                              {""}
                            </td>
                          </tr>

                          {state.statement.totalsByProvider.length > 0 ? (
                            <>
                              <tr>
                                <td
                                  className="px-6 py-1 font-medium"
                                  colSpan={4}
                                >
                                  Other Channel Sales
                                </td>
                              </tr>
                              {state.statement.totalsByProvider.map((item) => (
                                <tr>
                                  <td className="px-6 py-1 " colSpan={2}>
                                    {item.saleType} - {item.provider}
                                  </td>

                                  <td className="px-6 py-1  text-right">
                                    {currencyFormatter(item.transactionAmount)}
                                  </td>
                                  <td className="px-6 py-1"> </td>
                                </tr>
                              ))}

                              <tr>
                                <td
                                  className="px-6 py-1 font-medium"
                                  colSpan={2}
                                >
                                  Total Sales
                                </td>
                                <td className="px-6 py-1 font-medium text-right">
                                  {currencyFormatter(
                                    state.statement.salesTotal
                                  )}
                                  {/* {currencyFormatter(100000000000000)} */}
                                </td>
                                <td className="px-6 py-1"> </td>
                              </tr>
                            </>
                          ) : null}
                          <tr>
                            <td className="px-6 py-1 font-medium" colSpan={4}>
                              {""}
                            </td>
                          </tr>

                          {state.statement.commissionList.length > 0 ? (
                            <>
                              <tr>
                                <td
                                  className="px-6 py-1 font-medium"
                                  colSpan={4}
                                >
                                  Other Channels Commission
                                </td>
                              </tr>

                              {state.statement.commissionList.map((item) => (
                                <tr>
                                  <td className="px-6 py-1 " colSpan={2}>
                                    {item.commissionType} - {item.provider}
                                  </td>

                                  <td className="px-6 py-1  text-right">
                                    {currencyFormatter(item.transactionAmount)}
                                  </td>
                                  <td className="px-6 py-1"> </td>
                                </tr>
                              ))}
                              <tr>
                                <td
                                  className="px-6 py-1 font-medium"
                                  colSpan={2}
                                >
                                  Total Commission
                                </td>
                                <td className="px-6 py-1 font-medium text-right">
                                  {currencyFormatter(
                                    state.statement.creditedCommissionListTotal
                                  )}
                                  {/* {currencyFormatter(100000000000000)} */}
                                </td>
                                <td className="px-6 py-1"> </td>
                              </tr>
                            </>
                          ) : null}

                          <tr>
                            <td
                              className="px-6 py-1 font-medium"
                              colSpan={4}
                            ></td>
                          </tr>

                          {state.statement.reversalsList.length > 0 ? (
                            <tr>
                              <td className="px-6 py-1" colSpan={2}>
                                Reversals
                              </td>
                              <td className="px-6 py-1 font-medium text-right">
                                {currencyFormatter(
                                  state.statement.reversalsTotal
                                )}
                              </td>
                              <td className="px-6 py-1 font-medium"></td>
                            </tr>
                          ) : null}

                          <tr>
                            <td
                              className="px-6 py-1 font-medium"
                              colSpan={4}
                            ></td>
                          </tr>

                          <tr>
                            <td className="px-6 py-1">
                              {format(
                                state.endDate.toDate(),
                                "yyyy-MM-dd HH:mm:ss"
                              )}
                            </td>
                            <td className="px-6 py-1 font-medium">
                              Balance carried forward
                            </td>
                            <td className="px-6 py-1">{""}</td>
                            <td className="px-6 py-1 font-medium text-right">
                              {currencyFormatter(
                                state.statement.closingBalance
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    ) : (
                      <h3>
                        There are no financial transactions for selected period.
                      </h3>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {state.isLoading && <Loading />}
    </>
  );
}
